/* This is the EMIS Giga components add 2025-26 */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table
        style="height: 78px; width: 700px"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td style=" width: 300px; height: 25px; text-align: center;vertical-align: middle;">កន្លែង</td>
            <td style=" width: 150px; height: 25px; text-align: center;vertical-align: middle;">ចំនួន</td>
            <td style=" width: 150px; height: 25px; text-align: center;vertical-align: middle;">ស្ថានភាព</td>
          </tr>
          <!--Row 1-->
          <tr>
            <td class="row-data-left">អគារ</td>
            <td class="row-data">
              <numberinput v-model="data[0].dt[0]" class="number" />
            </td>
            <td class="row-data">              
              <v-select
                class="px-1"
                v-model="data[0].dt[1]"
                :items="intDes"
                item-text="text"
                item-value="value"
                outline            
                hide-details
                @keypress.native="onSelect3($event)"
              />            
            </td>
          </tr>
          <!--Row 2-->
          <tr>
            <td class="row-data-left">បន្ទប់</td>
            <td class="row-data">
              <numberinput v-model="data[1].dt[0]" class="number" />
            </td>
            <td class="row-data">              
              <v-select
                class="px-1"
                v-model="data[1].dt[1]"
                :items="intDes"
                item-text="text"
                item-value="value"
                outline            
                hide-details
                @keypress.native="onSelect2($event)"
              />            
            </td>
          </tr>        
          <!--Row 3-->
          <tr>
            <td class="row-data-left">សិស្សដែលអាចប្រើអ៊ីនធឺណិតបាន</td>
            <td class="row-data">
              <numberinput v-model="data[2].dt[0]" class="number" />
            </td>
            <td class="row-data">              
              <v-select
                class="px-1"
                v-model="data[2].dt[1]"
                :items="intDes"
                item-text="text"
                item-value="value"
                outline            
                hide-details
                @keypress.native="onSelect1($event)"
              />
            </td>
          </tr> 
          <!--Row 4-->
          <tr>
            <td class="row-data-left">អ៊ីនធឺណិតជួយសម្រួលការងារសាលារៀន</td>
            <td colspan="2">
              <v-select
                class="px-1"
                v-model="data[3].dt[0]"
                :items="intAffair"
                item-text="text"
                item-value="value"
                outline            
                hide-details
                @keypress.native="onSelect($event)"
              />
          </td>
          </tr> 
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { intAffair, intDes } from "@/utils/ascf/commonConfig.js";
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      intAffair: intAffair,
      intDes: intDes
    };
  },
  methods: {
    onSelect: function (event) {
      /* 2 options */
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data[3].dt[0] = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect1: function (event) {
      /* 2 options */
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data[2].dt[1] = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect2: function (event) {
      /* 2 options */
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data[1].dt[1] = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect3: function (event) {
      /* 2 options */
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data[0].dt[1] = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>
<style scoped>
.number {
  width: 300px;
  text-align: center;
}
.row-data {
  width: 100px;
  height: 35px;
  text-align: center;
  vertical-align: middle;
}
.row-data-left {
  width: 200px;
  height: 35px;
  text-align: left;
  vertical-align: middle;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
.v-input {
  font-size: 12px;
}
</style>